// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var SubmitFeedbackRequest_Rating;
(function (SubmitFeedbackRequest_Rating) {
    SubmitFeedbackRequest_Rating["RATING_UNKNOWN"] = "RATING_UNKNOWN";
    SubmitFeedbackRequest_Rating["RATING_NEGATIVE"] = "RATING_NEGATIVE";
    SubmitFeedbackRequest_Rating["RATING_POSITIVE"] = "RATING_POSITIVE";
})(SubmitFeedbackRequest_Rating || (SubmitFeedbackRequest_Rating = {}));
export var SubmitFeedbackRequest_Rating_index;
(function (SubmitFeedbackRequest_Rating_index) {
    SubmitFeedbackRequest_Rating_index[SubmitFeedbackRequest_Rating_index["RATING_UNKNOWN"] = 0] = "RATING_UNKNOWN";
    SubmitFeedbackRequest_Rating_index[SubmitFeedbackRequest_Rating_index["RATING_NEGATIVE"] = 1] = "RATING_NEGATIVE";
    SubmitFeedbackRequest_Rating_index[SubmitFeedbackRequest_Rating_index["RATING_POSITIVE"] = 2] = "RATING_POSITIVE";
})(SubmitFeedbackRequest_Rating_index || (SubmitFeedbackRequest_Rating_index = {}));
export const API = {
    GetCallQualityMetrics(fn, req) {
        return fn(`/phone-exp/phone-records-ext/call-quality/v1/metrics?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * SubmitFeedback submits the feedback for a call quality metrics from the customer
     */
    SubmitFeedback(fn, req) {
        return fn(`/phone-exp/phone-records-ext/call-quality/v1/feedback`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Trace is used to generate advanced trace data for a call. It will not be used by customers.
     */
    Trace(fn, req) {
        return fn(`/phone-exp/phone-records-ext/call-quality/v1/trace`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
